module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "cp-3d"
  }, [_c('div', {
    staticClass: "topBar"
  }, [_c('span', {
    staticClass: "btn-back iconfont",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.back()
      }
    }
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("3D")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "img-404",
    attrs: {
      "src": require("../../images/404.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goSS()
      }
    }
  }, [_vm._v("不好意思,未能抽出时间用Vue重写,请转至'双色球'！")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa259d16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/3d/3d.vue
// module id = 69
// module chunks = 0